<div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-start sm:p-0">
      <div
        class="relative transform overflow-hidden rounded-lg bg-surface px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6"
      >
        <div class="mt-3 text-center sm:mt-0 sm:text-left">
          <h3 class="text-base font-semibold leading-6 text-fg-primary" id="modal-title">
            Freie Rechnungsposition
          </h3>
          <div class="mt-2">
            <p class="text-sm text-fg-secondary">
              Erfasse eine Position unabhängig von den erfassten Stunden, zum Beispiel Material,
              Lizenzen oder einen Rabatt.
            </p>
          </div>
        </div>

        @if (freePositionForm) {
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-4 pt-6">
            <app-text-input
              label="Text"
              class="sm:col-span-2"
              [formControl]="freePositionForm.controls.displayName"
            ></app-text-input>
            <app-dropdown
              label="Einheit"
              [formControl]="freePositionForm.controls.unit"
              [options]="unitOptions"
            ></app-dropdown>
            <app-dropdown
              label="MwSt."
              [formControl]="freePositionForm.controls.vatRateType"
              [options]="vatRateOptions"
            ></app-dropdown>
            @if (isQuantityBased) {
              <app-number-input
                label="Menge"
                currencySymbol=""
                [formControl]="freePositionForm.controls.quantity"
              ></app-number-input>
              <app-number-input
                label="Preis/Einheit"
                variant="currency"
                [formControl]="freePositionForm.controls.unitPrice"
              ></app-number-input>
            } @else {
              <app-number-input
                label="Summe"
                variant="currency"
                class="sm:col-span-2"
                [formControl]="freePositionForm.controls.totalPrice"
              ></app-number-input>
            }
            <div class="sm:col-span-2 flex justify-end border-t border-edge pt-4">
              <span class="text-sm font-medium text-fg-primary tabular-nums">
                Summe&nbsp;&nbsp;{{ (totalPrice | async) ?? '0.00' | formatAmount }}
              </span>
            </div>
          </div>
        }

        <div class="mt-5 sm:mt-4 gap-2 sm:flex sm:flex-row-reverse">
          <button (click)="savePosition()" class="w-full sm:w-auto" type="button" appTailwindButton>
            {{ data.position ? 'Speichern' : 'Hinzufügen' }}
          </button>
          <button
            class="w-full sm:w-auto"
            (click)="cancelDialog()"
            color="secondary"
            type="button"
            appTailwindButton
          >
            Abbrechen
          </button>
        </div>

        <div class="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
          <button
            (click)="cancelDialog()"
            type="button"
            class="rounded-md bg-surface text-fg-faint hover:text-fg-secondary focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
          >
            <span class="sr-only">Close</span>
            <app-ng-icon class="text-2xl" name="heroXMark"></app-ng-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
